import type { ExperimentManifest } from '../types';
import { canonicalJson } from './canonical';
import { sha256 } from './hash';

export function computeReproducibilityScore(input: { seed:number; datasetVersion:string; datasetHash:string; parameters:Record<string, unknown>; metricsCount:number; runtimeKnown:boolean; }): number {
  let score = 0;
  if (Number.isInteger(input.seed)) score += 20;
  if (input.datasetVersion) score += 15;
  if (/^[a-f0-9]{64}$/i.test(input.datasetHash)) score += 20;
  if (Object.keys(input.parameters).length >= 0) score += 15;
  if (input.metricsCount > 0) score += 15;
  if (input.runtimeKnown) score += 15;
  return score;
}

export async function finalizeManifest(manifest: Omit<ExperimentManifest,'experimentId'>): Promise<ExperimentManifest> {
  const experimentId = (await sha256(canonicalJson(manifest))).slice(0, 16);
  return { ...manifest, experimentId };
}

export function buildPythonScript(manifest: ExperimentManifest): string {
  const p = JSON.stringify(manifest.parameters, null, 2);
  return `# Generated by AutoML Reproducibility Hub
# Experiment: ${manifest.experimentId}
# Dataset SHA-256: ${manifest.dataset.sha256}

SEED = ${manifest.seed}
TEST_SIZE = ${manifest.testSize}
TASK = ${JSON.stringify(manifest.task)}
MODEL = ${JSON.stringify(manifest.selectedModel)}
PARAMETERS = ${p}

# Load the exact dataset version and verify its SHA-256 before running.
# The browser application uses pandas + scikit-learn with deterministic train_test_split.
# See docs/REPRODUCIBILITY.md for the complete reference pipeline.
`;
}
